<template>
  <div class="footer">
      <slot></slot>
  </div>
</template>

<script>
export default {
    name: 'g-footer'
}
</script>

<style lang="scss" scoped>

</style>